import React from 'react'

const Footer = () => {
    return (
        <div>
            <p style={{textAlign:"center",fontWeight:"100"}}>Designed and built by Prem © 2021</p>
        </div>
    )
}

export default Footer;